import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { TabsTrigger } from "../components/ui/tabs"
import { cn } from "../lib/utils"
import { stripPresetConflicts } from "../lib/preset-utils"

export function TabTriggerRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const text = element.text
    ? String(resolveSymbol(element.text) ?? element.text)
    : ""

  // Check if this tab is selected by comparing with ui.selectedCategory
  const selectedCategory = resolveSymbol("#{ui.selectedCategory}")
  const isSelected = text === selectedCategory

  const handleClick = () => {
    if (element.events?.tap) {
      dispatchEvent(element.id, "tap", { value: text })
    }
  }

  return (
    <TabsTrigger
      value={text}
      aria-selected={isSelected}
      onClick={handleClick}
      className={cn(stripPresetConflicts(element.className))}
      data-active={isSelected || undefined}
    >
      {text}
    </TabsTrigger>
  )
}
